import React from "react";
import { Dropdown } from "react-bootstrap";
import { budgetLine } from "@/components/ShowcaseView";
import { ageOf } from "./showcaseManagerModel";

const Row = ({ item, first, last, dragging, over, onAction, dragProps }) => (
  <li
    className={`showcase-manager__row${item.pinned ? " is-pinned" : ""}${item.hidden ? " is-hidden" : ""}${
      dragging ? " is-dragging" : ""
    }${over ? " is-over" : ""}`}
    data-id={item.wantAdId}
    {...dragProps.row}
  >
    <span className="showcase-manager__grip" aria-hidden="true" {...dragProps.grip}>
      <svg viewBox="0 0 10 16" width="10" height="16">
        {[3, 8, 13].map((y) => (
          <React.Fragment key={y}>
            <circle cx="2.5" cy={y} r="1.4" />
            <circle cx="7.5" cy={y} r="1.4" />
          </React.Fragment>
        ))}
      </svg>
    </span>
    <div className="showcase-manager__text">
      <span className="showcase-manager__title">
        {item.pinned ? (
          <svg className="showcase-manager__pin" viewBox="0 0 16 16" width="14" height="14" aria-label="Pinned" role="img">
            <path d="M6 2h4l-.6 4 2.6 2.4V10H4V8.4L6.6 6zM8 10v4" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
          </svg>
        ) : null}
        {item.title}
      </span>
      <span className="showcase-manager__sub">
        {[budgetLine(item.budgetMin, item.budgetMax), item.agentName, item.location, ageOf(item.createdAt)]
          .filter(Boolean)
          .join(" · ")}
        {item.hidden ? <em> · Hidden from your site</em> : null}
      </span>
    </div>
    <Dropdown className="showcase-manager__menu" align="end">
      <Dropdown.Toggle variant="" className="showcase-manager__menu-toggle" aria-label={`Options for ${item.title}`}>
        <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">
          <circle cx="4" cy="10" r="1.7" fill="currentColor" />
          <circle cx="10" cy="10" r="1.7" fill="currentColor" />
          <circle cx="16" cy="10" r="1.7" fill="currentColor" />
        </svg>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item as="button" onClick={() => onAction("pin", item)}>
          {item.pinned ? "Unpin" : "Pin to the top"}
        </Dropdown.Item>
        <Dropdown.Item as="button" disabled={first} onClick={() => onAction("up", item)}>
          Move up
        </Dropdown.Item>
        <Dropdown.Item as="button" disabled={last} onClick={() => onAction("down", item)}>
          Move down
        </Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => onAction("hide", item)}>
          {item.hidden ? "Show on your site" : "Hide from your site"}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </li>
);

export default Row;
